// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2O4LS","col":"styles_col__3D7bV"};